import { render } from "./ShowPengecualian.vue?vue&type=template&id=777a1530"
import script from "./ShowPengecualian.vue?vue&type=script&lang=js"
export * from "./ShowPengecualian.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__